import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { generateSparesSearchUrl } from 'shared/helpers/urls';
import LinkList from 'shared/components/LinkList/LinkList';
import s from './SpareSeoLinks.css';

class SpareSeoLinks extends React.Component {
  static propTypes = {
    selected: PropTypes.shape(),
    location: PropTypes.shape(),
    seoCharacteristics: PropTypes.shape({
      part_types: PropTypes.arrayOf(PropTypes.shape()),
      rubrics: PropTypes.arrayOf(PropTypes.shape()),
    }).isRequired,
    isMobile: PropTypes.bool,
  };
  static defaultProps = {
    location: null,
    selected: null,
    isMobile: false,
  };

  buildLink = slug => {
    const { selected, location } = this.props;
    const isRubricSelected = !!selected.rubric;

    return `/${generateSparesSearchUrl({
      transport: selected.transport,
      ...(isRubricSelected
        ? {
            rubric: selected.rubric,
            sparetype: { slug },
          }
        : {
            rubric: { slug },
          }),
      make: selected.make,
      model: selected.model,
      location,
    })}`;
  };

  render() {
    const { seoCharacteristics = { part_types: [], rubrics: [] }, isMobile } = this.props;
    const list = [...seoCharacteristics.rubrics, ...seoCharacteristics.part_types];

    if (!list.length) {
      return null;
    }

    return (
      <div className={s.root}>
        <LinkList
          isMobile={isMobile}
          title={
            <FormattedMessage
              id={seoCharacteristics.part_types.length ? 'Подтип запчастей' : 'Тип запчастей'}
            />
          }
          buildLink={this.buildLink}
          list={list}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ searchForm, globals }) => ({
  selected: searchForm.selected,
  location: globals.location,
});
export default withStyles(s)(connect(mapStateToProps)(SpareSeoLinks));



// WEBPACK FOOTER //
// ./src/shared/components/SpareSeoLinks/SpareSeoLinks.js